import { EventTask } from "../model/EventTask"
import { PartyEvent } from "../model/PartyEvent"
import { Notification } from "../model/Notifications"

 type Item = {
    id: number
  }
  
  export const findItemIndexById = <TItem extends Item>(
    items: TItem[],
    id: number
  ) => {
    return items.findIndex((item: TItem) => item.id === id)
  }
  
  export const moveItem = <TItem>(
    array: TItem[],
    from: number,
    to: number
  ) => {
    const item = array[from]
    return insertItemAtIndex(removeItemAtIndex(array, from), item, to)
  }
  
  export function removeItemAtIndex<TItem>(
    array: TItem[],
    index: number
  ) {
    return [...array.slice(0, index), ...array.slice(index + 1)]
  }
  
  export function insertItemAtIndex<TItem>(
    array: TItem[],
    item: TItem,
    index: number
  ) {
    return [...array.slice(0, index), item, ...array.slice(index)]
  }

  export function comparePartyEventStarts( a : PartyEvent, b :PartyEvent, sortDescending : boolean) {
    let firstStartDate : Number = new Date(a.start ?? '0000-01-01T00:00:00').getTime()
    let secondStartDate : Number = new Date(b.start ?? '0000-01-01T00:00:00').getTime()
    if (firstStartDate < secondStartDate){
      if (sortDescending)
        return 1
      return -1
    }
    if (firstStartDate > secondStartDate) {
        if (sortDescending){
          return -1
        }
      return 1
    }
    return 0
  }

  export function compareNotificationDates( a : Notification, b :Notification, sortDescending : boolean) {
    let firstDate : Number = new Date(a.date ?? '0000-01-01T00:00:00').getTime()
    let secondDate : Number = new Date(b.date ?? '0000-01-01T00:00:00').getTime()
    if (firstDate < secondDate){
      if (sortDescending)
        return 1
      return -1
    }
    if (firstDate > secondDate) {
        if (sortDescending){
          return -1
        }
      return 1
    }
    return 0
  }


  